import { render, staticRenderFns } from "./ReportMaterialsConsumptions.vue?vue&type=template&id=c47efa88&"
import script from "./ReportMaterialsConsumptions.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsConsumptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QInput,QCheckbox} from 'quasar'
component.options.components = Object.assign({QBtn,QInput,QCheckbox}, component.options.components || {})
